/************************************************************************************

* [COMPONENT]: L-HEADER

*************************************************************************************/

class LTAHeader extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		// Elements
		this.cartLinkEls = this.querySelectorAll('[data-cart-link]')
		this.cartCountEls = this.querySelectorAll('[data-cart-count]')

		// Events
		this.handleCartLinkClick()
		this.setupHeaderType()
		this.scrollEvent()

		document.addEventListener('rebuy:cart.change', (event) => {
			const cart = event.detail.cart.cart

			this.cartLinkEls.forEach((cartLinkEl) => {
				const cartCountEl = cartLinkEl.querySelector('[data-cart-count]')

				cartCountEl.innerHTML = cart.item_count
			})
		})

		document.addEventListener('l:cart:updated', (event) => {
			const response = event.detail.response

			this.cartCountEls.forEach((cartCountEl) => {
				cartCountEl.innerHTML = response.item_count
			})
		})
	}

	scrollEvent() {
		const checkHeaderPosition = () => {
			const { headerSectionHeight } = l_setupVariablesBeforeOpenModal()
			const scrollPosition = window.scrollY || document.documentElement.scrollTop
			const isSticky = scrollPosition > 0

			this.classList.toggle('is-sticky', isSticky)
		}

		// Call default in the beginning
		checkHeaderPosition()

		// Catch scroll event
		document.addEventListener(
			'scroll',
			l_debounce(() => {
				checkHeaderPosition()
			}, 1)
		)
	}

	setupHeaderType() {
		this.classList.add(document.querySelector('.l-first-section-video') ? 'is-transparent-mode' : 'is-colored-mode')
	}

	handleCartLinkClick(event) {
		this.cartLinkEls.forEach((cartLinkEl) => {
			cartLinkEl.addEventListener('click', (event) => {
				event.preventDefault()

				window.Rebuy?.SmartCart?.show?.()
			})
		})
	}

	global_setupMode(modeName = 'colored') {
		this.classList.remove('is-transparent-mode', 'is-colored-mode')
		if (modeName) this.classList.add(`is-${modeName}-mode`)
	}
}

customElements.define('l-header', LTAHeader)

/************************************************************************************

* [COMPONENT]: L-HEADER-DRAWER-MOBILE

*************************************************************************************/

class LTAHeaderMobile extends LTADrawer {
	constructor() {
		super()
	}

	connectedCallback() {
		// Inherit from parent class
		super.connectedCallback()

		// Elements
		this.parentLinkEls = this.querySelectorAll('[data-parent-link]')
		this.menuGroupEls = this.querySelectorAll('[data-menu-group]')
		this.backBtnEls = this.querySelectorAll('[data-back-btn]')

		// Events
		this.handleToggleSubMenu()
	}

	handleToggleSubMenu() {
		// Open menus
		this.parentLinkEls.forEach((parentLinkEl) => {
			parentLinkEl.addEventListener('click', (event) => {
				event.preventDefault()

				const subMenuEl = this.querySelector(`#${parentLinkEl.dataset.parentLink}`)

				this.menuGroupEls.forEach((menuGroupEl) => {
					menuGroupEl.classList.toggle('l-hidden', menuGroupEl !== subMenuEl)
				})
			})
		})

		// Close menus
		this.backBtnEls.forEach((closeBtnEl) => {
			closeBtnEl.addEventListener('click', (event) => {
				event.preventDefault()

				const parentMenu = this.querySelector(`${closeBtnEl.dataset.backBtn}`)

				console.log(parentMenu)

				this.menuGroupEls.forEach((menuGroupEl) => {
					menuGroupEl.classList.toggle('l-hidden', menuGroupEl !== parentMenu)
				})
			})
		})
	}

	collapse(element) {
		const onTransitionEnd = ((event) => {
			if (event.target === element) {
				element.removeEventListener(this.transitionendEvent, onTransitionEnd)
			}
		}).bind(this)

		element.addEventListener(this.transitionendEvent, onTransitionEnd)
		this.isOpen = false
		this.classList.remove(this.expandedClass)

		requestAnimationFrame(() => {
			element.style.transition = '0'
			element.style.height = element.scrollHeight + 'px'

			requestAnimationFrame(() => {
				element.style.transition = null
				element.style.height = this.collapsedHeight
			})
		})
	}
}

customElements.define('l-header-drawer-mobile', LTAHeaderMobile)

/************************************************************************************

* [COMPONENT]: L-HEADER-MEGA-MENU

*************************************************************************************/
class LTAHeaderDesktop extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		// Data
		this.lv1LinkHandle = this.dataset.lv1Link
		this.touchEvents = ['mouseenter', 'pointerenter', 'touchstart']

		// Elements
		this.headerEl = document.getElementById('header')
		this.headerLevel1LinksEl = document.getElementById('headerLv1Links')
		this.containerEl = this.querySelector('[data-container]')
		this.level1LinkEl = this.headerLevel1LinksEl.querySelector(`[data-lv1-link="${this.lv1LinkHandle}"]`)

		this.level2LinkEls = this.querySelectorAll('[data-lv2-link]')
		this.menuLevel3Els = this.querySelectorAll('[data-menu-lv3]')

		this.bannerEls = Array.from(this.querySelectorAll('[data-banner]'))

		// Events
		this.handleOpenEvents()
		this.handleTriggerMenuLevel3()

		// Global events
		document.addEventListener('header-menu-open', (event) => {
			const lv1LinkHandle = event.detail.lv1LinkHandle

			if (lv1LinkHandle != this.lv1LinkHandle) this.closeMenu()
		})
	}

	handleOpenEvents() {
		// Open events
		this.touchEvents.forEach((eventType) => {
			this.level1LinkEl.addEventListener(eventType, (event) => {
				event.preventDefault()

				// Close other menus
				document.dispatchEvent(
					new CustomEvent('header-menu-open', { bubbles: true, detail: { lv1LinkHandle: this.lv1LinkHandle } })
				)

				// Setup global variables
				l_setupVariablesBeforeOpenModal()

				// Lock screen
				l_lockBodyScroll()

				// Setup header class
				this.headerEl.global_setupMode()

				// Open the menu
				this.classList.remove('l-hidden')
				requestAnimationFrame(() => {
					this.classList.add('is-open')
				})
			})
		})

		// Close events
		document.addEventListener('click', this.closeMenu.bind(this))
	}

	handleTriggerMenuLevel3() {
		this.level2LinkEls.forEach((level2LinkEl) => {
			this.touchEvents.forEach((eventType) => {
				level2LinkEl.addEventListener(eventType, (event) => {
					const linkHandle = level2LinkEl.dataset.lv2Link

					this.menuLevel3Els.forEach((menuLevel3El) => {
						// Trigger menu level 3
						menuLevel3El.classList.toggle('l-hidden', menuLevel3El.dataset.menuLv3 !== linkHandle)

						// Trigger banner
						if (this.bannerEls.length > 0) {
							let hasBanner = false
							this.bannerEls.forEach((bannerEl) => {
								bannerEl.classList.toggle('l-hidden', bannerEl.dataset.banner !== linkHandle)

								hasBanner = bannerEl.dataset.banner == linkHandle
							})

							//if (!hasBanner) this.bannerEls[0].classList.remove('l-hidden')
						}
					})
				})
			})
		})
	}

	closeMenu(event) {
		const closeCondition =
			!event || (!this.containerEl.contains(event.target) && !this.level1LinkEl.contains(event.target))

		if (closeCondition && !this.classList.contains('l-hidden')) {
			// Setup header class
			this.headerEl.global_setupMode('transparent')

			// Close events
			this.classList.remove('is-open')

			// Unlock body
			l_unLockBodyScroll()

			l_debounce(() => {
				this.classList.add('l-hidden')
			}, 400)()
		}
	}
}

customElements.define('l-mega-menu', LTAHeaderDesktop)

/************************************************************************************

* [COMPONENT]: L-HEADER-SEARCH-DRAWER

*************************************************************************************/
class LTAHeaderSearchDrawer extends LTADrawer {
	constructor() {
		super()
	}

	connectedCallback() {
		super.connectedCallback()

		// Elements
		this.formEl = this.querySelector('form')
		this.suggestionsEl = this.querySelector('[data-suggestions]')
		this.searchInputEl = this.querySelector('[data-search-input]')
		this.searchBtnEl = this.querySelector('[data-search-btn]')
		this.searchResultsEl = this.querySelector('[data-search-results]')
		this.clearBtnEl = this.querySelector('[data-search-clear]')
		this.loadingEl = this.querySelector('[data-search-loading]')

		// Data
		this.cachedResults = {}

		// Events
		const debouncedOnChange = l_debounce((event) => {
			this.handleSearchTermChange(event)
		}, 300)

		this.formEl.addEventListener('submit', debouncedOnChange.bind(this))
		this.searchInputEl.addEventListener('input', debouncedOnChange.bind(this))
		this.clearBtnEl.addEventListener('click', this.handleClearSearch.bind(this))

		// Run functions
		this.handleSearchTermsClickEvent()
		this.handleOnSearchPage()
	}

	handleSearchTermChange() {
		const queryKey = this.searchInputEl.value.replace(' ', '-').toLowerCase()

		// Setup loading state
		this.enableLoadingState()

		if (this.cachedResults[queryKey]) {
			this.renderSearchResults(this.cachedResults[queryKey])
			return
		}

		// Fetch predictive search results
		const searchURL = `${window.themeVariables.routes.predictive_search_url}?q=${encodeURIComponent(queryKey)}&section_id=a-ajax-header-predictive-search`

		fetch(searchURL)
			.then((response) => {
				return response.text()
			})
			.then((htmlText) => {
				const resultsMarkup = l_getSectionDOM(htmlText, '#shopify-section-a-ajax-header-predictive-search')

				// Cache results
				this.cachedResults[queryKey] = resultsMarkup

				// Render results
				this.renderSearchResults(resultsMarkup)
			})
			.catch((error) => {
				console.error(error)

				this.disableLoadingState()
			})
	}

	handleSearchTermsClickEvent() {
		this.suggestionTermEls = this.querySelectorAll('[data-term-suggestion]')

		this.suggestionTermEls.forEach((suggestionTermEl) => {
			suggestionTermEl.addEventListener('click', (event) => {
				event.preventDefault()

				const searchTerm = suggestionTermEl.dataset.termSuggestion

				this.searchInputEl.value = searchTerm
				this.searchInputEl.focus()

				this.formEl.dispatchEvent(new Event('submit'))
			})
		})
	}

	renderSearchResults(resultsMarkup) {
		this.searchResultsEl.innerHTML = resultsMarkup.innerHTML

		// Remove loading state
		this.disableLoadingState()
	}

	handleClearSearch() {
		this.searchInputEl.value = ''
		this.searchInputEl.focus()

		this.searchResultsEl.innerHTML = ''

		this.loadingEl.classList.add('l-hidden')
		this.searchResultsEl.classList.remove('is-loading')
		this.searchResultsEl.classList.add('is-no-search')
	}

	handleOnSearchPage() {
		const templateName = this.dataset.templateName

		const isSearchPageWithoutQuery = () => {
			const currentURL = window.location.pathname
			const isSearchPageWithoutQuery = currentURL == this.dataset.searchUrl && window.location.search == ''

			return isSearchPageWithoutQuery
		}

		// Check if the current page is the search page
		if (templateName == 'search') {
			if (isSearchPageWithoutQuery()) this.drawer_open()
		}

		// Setup popstate event listener
		window.addEventListener('popstate', () => {
			if (isSearchPageWithoutQuery()) this.drawer_open()
		})
	}

	enableLoadingState() {
		this.loadingEl.classList.remove('l-hidden')
		this.searchResultsEl.classList.add('is-loading')
		this.searchBtnEl.classList.add('is-loading')
	}

	disableLoadingState() {
		this.loadingEl.classList.add('l-hidden')
		this.searchResultsEl.classList.remove('is-loading')
		this.searchBtnEl.classList.remove('is-loading')
		this.searchResultsEl.classList.remove('is-no-search')
	}

	drawer_open() {
		super.drawer_open()

		this.searchInputEl.focus()
	}
}

customElements.define('l-header-search-drawer', LTAHeaderSearchDrawer)

